@if (!loading) {
  <app-breadcrumb
    listado="/main/administracion/trackers"
    etiquetaListado="Trackers"
    [titulo]="tracker?.identificacion || tracker?.nombre"
  ></app-breadcrumb>

  <!-- Encabezado con la misma estética que las tarjetas de la pestaña Info -->
  <header class="encabezado">
    <div class="encabezado-avatar"><mat-icon>gps_fixed</mat-icon></div>
    <div class="encabezado-texto">
      <h1>{{ tracker?.identificacion || tracker?.nombre }}</h1>
      @if (tracker?.nombre && tracker?.identificacion) {
        <span class="encabezado-nombre">{{ tracker.nombre }}</span>
      }
      <div class="encabezado-chips">
        @if (tracker?.tipo) {
          <span class="chip">
            <mat-icon>category</mat-icon>
            {{ tracker.tipo }}
          </span>
        }
        @for (chip of chips; track $index) {
          <span class="chip">
            @if (chip.icon) {
              <mat-icon>{{ chip.icon }}</mat-icon>
            }
            {{ chip.label }}
          </span>
        }
      </div>
    </div>
    @if (puedeEditar) {
      <button
        irxBotonIcono
        class="encabezado-editar"
        (click)="editar()"
        tooltip="Editar tracker"
      >
        <mat-icon>edit</mat-icon>
      </button>
    }
  </header>

  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    (selectedTabChange)="tabChanged($event)"
    class="tabs-detalle"
  >
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">info</mat-icon>
        <span>Info</span>
      </ng-template>
      <ng-template matTabContent>
        <app-detalles-tracker-info></app-detalles-tracker-info>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">report</mat-icon>
        <span>Historial Eventos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-eventos-genericos-historico
          [id]="tracker?._id"
        ></app-eventos-genericos-historico>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">description</mat-icon>
        <span>Historial Reportes</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-reportes-genericos
          [entidad]="tracker"
          tipoEntidad="Tracker"
          [tipoValoresReporte]="[
            helper.tipoTrackerATipoValoresReporte(tracker),
          ]"
        ></app-listado-reportes-genericos>
      </ng-template>
    </mat-tab>

    <!-- Combustible -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">local_gas_station</mat-icon>
        <span>Combustible</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-reportes-combustible
          [idTracker]="tracker?._id"
        ></app-listado-reportes-combustible>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">integration_instructions</mat-icon>
        <span>Códigos Eventos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-configs-eventos
          [dispositivo]="tracker"
          [tipo]="'Tracker'"
        ></app-listado-configs-eventos>
      </ng-template>
    </mat-tab>

    <!-- Asignaciones (SIMs y activo) -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">assignment</mat-icon>
        <span>Asignaciones</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-asignacions
          [idEntidad]="tracker?._id"
          tipoEntidad="modificada"
        ></app-listado-asignacions>
      </ng-template>
    </mat-tab>

    @if (helper.tienePermiso('Logs - Ver logs crudos trackers')) {
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">terminal</mat-icon>
          <span>Logs Crudos</span>
        </ng-template>
        <ng-template matTabContent>
          <app-listado-logs-crudos
            [idEntidad]="tracker?._id"
            tipoEntidad="Tracker"
          ></app-listado-logs-crudos>
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
} @else {
  <app-detalle-esqueleto
    icono="gps_fixed"
    listado="/main/administracion/trackers"
    etiquetaListado="Trackers"
    [pestanas]="7"
  ></app-detalle-esqueleto>
}
